'use strict';

function noop () {}

function getSelectionNullOp () {
  return {
    removeAllRanges: noop,
    addRange: noop
  };
}

module.exports = getSelectionNullOp;



//////////////////
// WEBPACK FOOTER
// ./~/seleccion/src/getSelectionNullOp.js
// module id = 299
// module chunks = 0